import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class Loader extends Component {

  /* Render */

  render() {
    let loaderCircleStyle;
    const { size, color } = this.props;
    const modifier = size ? `loader--${size}` : '';

    if (color) {
      loaderCircleStyle = {
        borderTopColor: color,
      };
    }

    if (this.props.visible) {
      return (
        <div className={`loader ${modifier}`}>
          <div className="loader__circle" style={loaderCircleStyle} />
        </div>
      );
    }

    return null;
  }
}

Loader.defaultProps = {
  visible: true,
};

Loader.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  visible: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./js/components/loader/index.jsx